import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FinalComponent } from './final.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

@NgModule({
  declarations: [
    FinalComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    LocalizeRouterModule,
    RouterModule
  ],
  exports: [
    FinalComponent
  ]
})

export class FinalModule { }
